
import { Injectable } from '@nestjs/common';
import { appConfig } from 'apps/services/whatsapp-broad-cast/config';
import { Connection, ConnectionOptions, createConnection, getConnection } from 'typeorm';


@Injectable()
export class GymDbConnection {
    constructor() { }

    async getGymDbConnection(companyCode: string): Promise<Connection> {
        const connectionString: ConnectionOptions = {
            type: appConfig.thirdPartyDatabase[companyCode].type,
            host: appConfig.thirdPartyDatabase[companyCode].host,
            port: appConfig.thirdPartyDatabase[companyCode].port,
            username: appConfig.thirdPartyDatabase[companyCode].username,
            password: appConfig.thirdPartyDatabase[companyCode].password,
            database: appConfig.thirdPartyDatabase[companyCode].dbName,
            synchronize: false,
            name: companyCode,
            options: {
                // encrypt: true,
                enableArithAbort: true
            }
        }
        let connection;
        try {
            connection = getConnection(companyCode);
            if (!connection?.isConnected) {
                throw null;
            }
        } catch (error) {
            connection = await createConnection(connectionString);
        }
        return connection;
    }

    async closeConnection(companyCode: string) {
        return true;
        try {
            const connection = getConnection(companyCode);
            await connection.close();
            return true;
        } catch (error) {
            return false;
        }
    }
}